var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-wrapper',[_c('form-wrapper',[_c('register-form'),_c('hr'),_c('go-to-link',{attrs:{"question":"Already have an account?","label":"Log In","routeName":"login"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }